export default __webpack_public_path__ + "3a6597987b5fdca1ee3154b195e58a4d.png";